import React, { useEffect, useState } from "react";
import "./datatable.scss";
import {
  Space,
  Table,
  Input,
  Button,
  Popover,
  message,
  Modal,
  Form,
  Select,
  Checkbox,
} from "antd";
import type { ColumnsType } from "antd/es/table";

interface Contentdata {
  full_name?: string;
  email: number;
  package_name: string;
  request_type: string;
  phone_number: string;
  company: {
    name: string;
  };
  user: {
    full_name: string;
    email: string;
  };
  _id: string;
  isComplete: boolean;
  reference_id: string;
}

interface DataTableProps {
  contentData: Contentdata[];
}
function ExclusiveOnlineEventsTable({ contentData }: DataTableProps) {
  const [searchText, setSearchText] = useState("");
  const [pagination, setPagination] = useState<any>({ page: 1, pageSize: 5 });
  const { Option } = Select;

  useEffect(() => {
    console.log(contentData, "contentData");
  }, [contentData]);

  const columns: ColumnsType<Contentdata> = [
    {
      title: "Reference ID",
      dataIndex: "reference_id",
      render: (record) => <div className="truncate">{record}</div>,
      filteredValue: [searchText],
      onFilter: (value, record) => {
        return (
          String(record?.company)
            .toLowerCase()
            .includes(value.toLocaleString()) ||
          String(record?.package_name)
            .toLowerCase()
            .includes(value.toLocaleString()) ||
          String(record?.full_name)
            .toLowerCase()
            .includes(value.toLocaleString()) ||
          String(record?.reference_id)
            .toLowerCase()
            .includes(value.toLocaleString())
        );
      },
    },
    {
      title: "Business Name",
      dataIndex: "company",
      key: "company",

      defaultSortOrder: "descend",
      render: (record) => <div className="truncate">{record}</div>,
      // sorter: (a: any, b: any) => a._id.localeCompare(b.company),
      ellipsis: true,
    },
    {
      title: "Name",
      dataIndex: "full_name",
      render: (record) => <div className="truncate">{record}</div>,
    },
    {
      title: "Email",
      dataIndex: "email",
      render: (record) => <div className="truncate">{record}</div>,
    },
    {
      title: "Phone",
      dataIndex: "phone_number",
      key: "phone_number",
      render: (record) => <div className="truncate">+{record}</div>,
    },
    // {
    //   title: "Plan Details",
    //   dataIndex: "package_name",
    //   key: "package_name",
    //   render: (record) => <div className="truncate">{record}</div>,
    // },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space style={{ margin: "0 auto" }}>
          {record.isComplete ? (
            <Button disabled={record.isComplete ? true : false}>
              Approved
            </Button>
          ) : (
            <Popover
              content={
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "10px",
                  }}
                >
                  <Button
                    style={{
                      backgroundColor: "#479751",
                      color: "#fff",
                      width: "100%",
                    }}
                    //onClick={() => ApprovCompany(record._id, "approved")}
                  >
                    Approve
                  </Button>
                </div>
              }
              title="Please Double click to delete."
            >
              <Button style={{ border: "none", color: "#2E3191" }}>
                Action
              </Button>
            </Popover>
          )}
        </Space>
      ),
    },
  ];

  return (
    <>
      <div className="dataTable">
        <div className="filterMenu">
          <div></div>
          <Input.Search
            onSearch={(value) => {
              setSearchText(value.toLowerCase());
            }}
            onChange={(e) => {
              setSearchText(e.target.value.toLowerCase());
            }}
            className="searchField"
            placeholder="Search here..."
          />
        </div>
        <Table
          scroll={{ y: 500 }}
          className="dataGrid"
          columns={columns}
          dataSource={contentData}
          pagination={{
            pageSize: pagination?.pageSize,
            onChange(page, pageSize) {
              setPagination(pageSize);
            },
            showSizeChanger: true,
          }}
        />
      </div>
    </>
  );
}

export default ExclusiveOnlineEventsTable;
